"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
/* REUSABLE */
var channels = new _1.default({ r: 0, g: 0, b: 0, a: 0 }, 'transparent');
/* EXPORT */
exports.default = channels;



//////////////////
// WEBPACK FOOTER
// ./~/khroma/dist/channels/reusable.js
// module id = 213
// module chunks = 0